module.exports = __webpack_public_path__ + "static/img/user-info-bg.427fd48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/user-info-bg.png
// module id = rzXN
// module chunks = 215